import { DialogHelper } from '@juvare/common-web-ui/DialogHelper';
import { SnackbarHelper } from '@juvare/common-web-ui/SnackbarHelper';
import { LoginCompletionWizard } from '@juvare/contact-management/ui/features/registration';
import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { baseName } from './constants';
import { useWindowTitle } from './hooks';
import { ContactManagementConfigProviderUser, FormConfigContextProvider } from './providers';

export const LoginCompletionApp: React.FC = () => {
    return <RouterProvider router={createBrowserRouter([{ path: '*', element: <LoginCompletionAppContent /> }], { basename: baseName })} />;
};

const LoginCompletionAppContent: React.FC = () => {
    useWindowTitle();
    return (
        <ContactManagementConfigProviderUser>
            <FormConfigContextProvider>
                <DialogHelper />
                <SnackbarHelper />
                <LoginCompletionWizard />
            </FormConfigContextProvider>
        </ContactManagementConfigProviderUser>
    );
};
